import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Stack } from '@mui/material'
import React, { SubmitEvent, useEffect, useState } from 'react'
import { IssueTypeSelect } from '../../../components/entities/IssueType'
import { ChooseShare } from './ChooseShare'
import ShareApi from '../../../api/ShareApi'
import { IssueType, ShareListItem } from '@finance-lab/utils/types'

const shareApi = new ShareApi()

export const NewIssueQuickForm = ({
    company,
    open,
    setOpen,
    handleCreateIssue,
}: {
    company: { id: string }
    setOpen: (v: boolean) => void
    open: boolean
    handleCreateIssue: (v: { shareId: string; type: Exclude<IssueType, 'IPO'> }) => Promise<void>
}) => {
    const [shares, setShares] = useState<ShareListItem[] | null>(null)
    const [share, setShare] = useState<ShareListItem | null>(null)
    const [issueType, setIssueType] = useState<Exclude<IssueType, 'IPO'> | null>(null)
    const [submitting, setSubmitting] = useState(false)

    useEffect(() => {
        const fetchData = async () => {
            if (!company) return
            const result = await shareApi.findByCompanyId(company.id)
            setShares(result)
        }
        void fetchData()
    }, [company])
    if (!company) return null
    const handleClose = () => {
        setShare(null)
        setIssueType(null)
        setSubmitting(false)
        setOpen(false)
    }
    return (
        <Dialog
            open={open}
            onClose={handleClose}
            slotProps={{
                paper: {
                    component: 'form',
                    onSubmit: (event: SubmitEvent) => {
                        event.preventDefault()
                        if (submitting) return

                        if (!share) {
                            alert('Ingen aktie vald')
                            return
                        }

                        if (!issueType) {
                            alert('Ingen emissionstyp vald')
                            return
                        }

                        setSubmitting(true)
                        const issueData = { shareId: share.id, type: issueType }
                        handleCreateIssue(issueData)
                            .then(() => {
                                handleClose()
                            })
                            .catch((err) => console.error(err))
                            .finally(() => {
                                setSubmitting(false)
                            })
                    },
                },
            }}
        >
            <DialogTitle>Ny emission för {company.name}</DialogTitle>
            <DialogContent>
                <Stack spacing={2}>
                    <ChooseShare shares={shares} share={share} setShare={setShare} />
                    <IssueTypeSelect
                        value={issueType}
                        onChange={(e) => setIssueType(e.target.value)}
                        displayEmpty
                        variant='outlined'
                        excludedIssueTypes={['IPO']}
                    />
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Avbryt</Button>
                <Button type='submit'>Skapa {submitting && <CircularProgress />}</Button>
            </DialogActions>
        </Dialog>
    )
}
